// extracted by mini-css-extract-plugin
export var adjacentSlide = "_np-9";
export var arrowButtonContainer = "_np-5";
export var arrowButtonIcon = "_np-6";
export var carouselArrowButton = "_np-2";
export var carouselElementContainer = "_np-1";
export var currentSlide = "_np-8";
export var left = "_np-3";
export var otherSlide = "_np-a";
export var productCarouselContainer = "_np-0";
export var right = "_np-4";
export var sliderOverflow = "_np-7";